import { useState } from 'react'
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded'
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded'
import { BottomSheet } from './BottomSheet'
import { OverflowTip } from './Hover/OverflowTip'
import { Button } from './Button'
import { Pressable } from './Pressable'
import './sheetDateField.css'

type SheetDateFieldProps = {
  ariaLabel: string
  value: string
  type: 'date' | 'time'
  placeholder: string
  disabled?: boolean
  onChange: (value: string) => void
}

/** Native controls live inside the shared sheet so Capacitor can use its system picker. */
export const SheetDateField = ({ ariaLabel, value, type, placeholder, disabled = false, onChange }: SheetDateFieldProps) => {
  const [open, setOpen] = useState(false)
  const [pending, setPending] = useState(value)
  const [prevOpen, setPrevOpen] = useState(open)
  const [prevValue, setPrevValue] = useState(value)
  if (prevOpen !== open || prevValue !== value) {
    setPrevOpen(open)
    setPrevValue(value)
    if (open) {
      setPending(value)
    }
  }
  const Icon = type === 'date' ? CalendarTodayRoundedIcon : ScheduleRoundedIcon
  return <>
    <Pressable className={`sheetSelectTrigger ${!value ? 'isPlaceholder' : ''}`} aria-label={ariaLabel} disabled={disabled} onClick={() => setOpen(true)}>
      <OverflowTip label={value || placeholder}>
        <span>{value || placeholder}</span>
      </OverflowTip>
      <Icon fontSize="small" aria-hidden />
    </Pressable>
    <BottomSheet isOpen={open} onClose={() => setOpen(false)} title={ariaLabel} className="sheetDateField">
      <div className="sheetDateField__body">
        <input aria-label={`${ariaLabel} value`} type={type} value={pending} onChange={(event) => setPending(event.target.value)} />
        <footer className="sheetDateField__footer">
          <Button variant="tertiary" size="md" onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="primary" size="lg" onClick={() => { onChange(pending); setOpen(false) }}>Done</Button>
        </footer>
      </div>
    </BottomSheet>
  </>
}
